export var TargetType;
(function (TargetType) {
    TargetType["Blank"] = "_blank";
    TargetType["Self"] = "_self";
    TargetType["Parent"] = "_parent";
    TargetType["Top"] = "_top";
})(TargetType || (TargetType = {}));
